
    import {defineComponent, toRefs, reactive, ComputedRef, computed, watch} from 'vue'
    import {useStore} from '@/store';
    import common from "@/util/common.ts";

    interface State {
        isShpwAntiFake: boolean;
        antiFakeUrl: string;
    }
    export default defineComponent({
        name: "reminderText",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                isShpwAntiFake: false,
                antiFakeUrl: ''
            })
            
            const {renderData} = toRefs(props);
            let store = useStore()
            function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value, code, key, type)
            }
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            watch(reportData, (data: any) => {
                const {componentList} = JSON.parse(JSON.stringify(data));
                const antiFake = componentList.find(item => item.code === 'antiFakeUrl');
                if (antiFake) {
                    state.isShpwAntiFake = true;
                    state.antiFakeUrl = common.getDataByCode(antiFake.configItems, 'antiFakeUrl', 'value', '');
                }
            }, {immediate: true, deep: true})
            
            return {
                state,
                getData
            }
        },
    })
